import React, { ReactNode } from 'react';
import { useAuth } from '../context';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAuth?: boolean;
  fallback?: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true,
  fallback = <div>Access denied</div>,
}) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className='loading'>Loading...</div>;
  }

  if (requireAuth && !isAuthenticated) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
